export enum TransactionState {
  inMempool = 'IN_MEMPOOL',
  confirmed = 'CONFIRMED',
}
